import axios from "../utils/axios";

// ==========================================
// Admin Reports
// ==========================================

export const getReportKpis = async (params) => {
    const response = await axios.get("/admin/reports/kpis", { params });
    return response.data;
};

export const getReportRevenue = async (params) => {
    const response = await axios.get("/admin/reports/revenue", { params });
    return response.data;
};

export const getReportTopProducts = async (params) => {
    const response = await axios.get("/admin/reports/top-products", { params });
    return response.data;
};

export const getReportTopCategories = async (params) => {
    const response = await axios.get("/admin/reports/top-categories", { params });
    return response.data;
};

export const getReportTopBrands = async (params) => {
    const response = await axios.get("/admin/reports/top-brands", { params });
    return response.data;
};

export const getReportNewCustomers = async (params) => {
    const response = await axios.get("/admin/reports/new-customers", { params });
    return response.data;
};

export const getReportPaymentBreakdown = async (params) => {
    const response = await axios.get("/admin/reports/payment-breakdown", { params });
    return response.data;
};

export const getReportOrderStatusBreakdown = async (params) => {
    const response = await axios.get("/admin/reports/order-status-breakdown", { params });
    return response.data;
};
